import React from 'react';

import OtherFeedback from 'screens/Profile/competencySection/components/OtherFeedback';
import styled from 'styled-components';

import { useLevelUpContext } from '../context';
import JobCompetencySection from './JobCompetencySection';
import { Header } from './JobRoleHeader';

const Container = styled.div`
  width: 100%;
`;

const RoleCompetencyScreen = ({ employee }) => {
  const {
    state: { levelUpDetails, isLoading, selectedOption, selectOptions },
    setSelectedOption,
  } = useLevelUpContext();

  const selectedJobCompetency = levelUpDetails?.jobCompetencies[selectedOption?.index];

  const { levelUpId, jobFunction, jobRole, isCurrentRole, competencies } = selectedJobCompetency ?? {};

  if (selectedJobCompetency)
    return (
      <Container>
        <Header selectedOption={selectedOption} setSelectedOption={setSelectedOption} selectOptions={selectOptions} />

        <JobCompetencySection
          key={jobRole.uuid}
          levelUpId={levelUpId}
          jobFunction={jobFunction}
          jobRole={jobRole}
          isCurrentRole={isCurrentRole}
          competencies={competencies}
          showWorkTowardsNewRole={levelUpDetails?.jobCompetencies?.length === 1}
        />
        <OtherFeedback employeeId={employee?.id} />
      </Container>
    );

  return null;
};

export default RoleCompetencyScreen;
